import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const FasterPointsIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--faster-points-icon')}
    viewBox="0 0 39 39"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-95.000000, -2699.000000)">
        <g transform="translate(85.000000, 2688.000000)">
          <g fill="#000000" fillRule="nonzero">
            <g transform="translate(10.000000, 11.000000)">
              <rect
                x="2.55509804"
                y="14.595"
                width="8.87357843"
                height="1.125"
              />
              <rect
                x="0.654166667"
                y="18.3"
                width="8.87357843"
                height="1.125"
              />
              <rect
                x="4.45602941"
                y="10.89"
                width="8.87357843"
                height="1.125"
              />
              <path d="M17.9934314,24.9375 L16.3464706,19.9875 L15.2459314,16.695 L14.1453922,19.9875 L12.4984314,24.9375 L7.15735294,24.9375 L3.60176471,24.9375 L6.47240196,26.97 L10.797598,30.03 L9.15063725,34.98 L8.05009804,38.2725 L10.9207353,36.24 L15.2459314,33.18 L19.5711275,36.24 L22.4417647,38.2725 L21.3412255,34.98 L19.6942647,30.03 L24.0194608,26.97 L26.890098,24.9375 L23.3345098,24.9375 L17.9934314,24.9375 Z M18.3320588,29.6025 L20.2406863,35.3325 L15.2382353,31.7925 L10.2357843,35.3325 L12.1444118,29.6025 L7.14196078,26.0625 L13.3219118,26.0625 L15.2305392,20.3325 L17.1391667,26.0625 L23.3191176,26.0625 L18.3320588,29.6025 Z" />
              <path d="M39.0114216,8.2725 L35.4558333,8.2725 L30.1147549,8.2725 L28.4677941,3.3225 L27.3672549,0.03 L26.2667157,3.3225 L24.6197549,8.2725 L19.2786765,8.2725 L15.7230882,8.2725 L18.5937255,10.305 L22.9189216,13.365 L21.2719608,18.315 L20.1714216,21.6075 L23.0420588,19.575 L27.3672549,16.515 L31.692451,19.575 L34.5630882,21.6075 L33.462549,18.315 L31.8155882,13.365 L36.1407843,10.305 L39.0114216,8.2725 Z M30.4610784,12.9375 L32.3697059,18.6675 L27.3672549,15.1275 L22.3648039,18.6675 L24.2734314,12.9375 L19.2709804,9.3975 L25.4509314,9.3975 L27.3595588,3.6675 L29.2681863,9.3975 L35.4481373,9.3975 L30.4610784,12.9375 Z" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default FasterPointsIcon;
